import React from 'react';
import SectionText from '../../presentational/SectionText';
import DotPoints from '../../presentational/DotPoints';
import data from '../../../core/data';
import Image from '../../presentational/Image';

function HistoryContainer(props) {
  return (
    <section id="bb-history">
      <div className="flow-backdrop hidden-sm hidden-xs" />
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <p>
              <span className="drop-text">
                { data.bbcream.history.bodyFirstLetter }
              </span>
              { data.bbcream.history.bbBody }
            </p>
            <DotPoints array={ data.bbcream.history.points } />
            <div className="col-sm-offset-2 col-sm-8">
              <DotPoints array={ data.bbcream.history.shades } />
            </div>
          </div>
        </div>
        <div className="row spacer">
          <div className="col-md-12">
            <div className="stamp-overlay">
              <div className="stamp">
                <em>Did you know?</em>
                { data.bbcream.whatIsBB.body }
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HistoryContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/BBPage/HistoryContainer.jsx
 **/